import { leadsSourceMap, leadsSubSourceMap, xuanjLeadsSubSourceMap } from '../pages/setting/clue/leadsSourceMap';
import { leadsTypeTree } from '../../consts/leadsTypeTree';
import { Tags } from '../../consts/Tags';
import { isShowLeadsSubSource } from '../../utils/whiteList';
import { isXunda } from '../../utils';

const getXundaPoolKeyName = () => {
  if (isXunda('车')) return '商家';
  return '楼盘';
};

export const standardFieldMap = {
  leadsSource: {
    value: 'leadsSource',
    label: '线索来源',
    type: 'Select',
    placeholder: '请选择线索来源',
    data: Object.keys(leadsSourceMap).map((key) => ({
      value: key,
      label: leadsSourceMap[key],
    })),
  },
  actionSubType__leadsSubType: {
    value: 'actionSubType__leadsSubType',
    label: '线索类型',
    placeholder: '请选择线索类型',
    type: 'SelectTree',
    data: leadsTypeTree,
  },
  // 需要注意这个字段会用到后台拉取的下拉菜单
  // 所以在使用的地方进行了重写而并没有用到下面全部的数据
  campaignId: {
    value: 'campaignId',
    label: '推广计划',
    placeholder: '请选择推广计划',
    type: 'Select',
    data: [],
  },
  adId: {
    value: 'adId',
    label: '广告ID',
    placeholder: '请输入广告ID，多个以英文逗号分隔',
    type: 'Input',
  },
  pageId: {
    value: 'pageId',
    label: '落地页ID',
    placeholder: '请输入落地页ID，多个以英文逗号分隔',
    type: 'Input',
  },
  componentId: {
    value: 'componentId',
    label: '组件ID',
    placeholder: '请输入组件ID，多个以英文逗号分隔',
    type: 'Input',
  },
  uid__wechatAppId: {
    value: 'uid__wechatAppId',
    label: '账户ID',
    placeholder: '请输入账户ID，多个以英文逗号分隔',
    type: 'Input',
  },
  // add by fighting
  adName: {
    value: 'adName',
    label: '广告名称',
    placeholder: '请输入广告名称关键字，多个关键字以英文逗号隔开',
    type: 'Input',
  },
  campaignName: {
    value: 'campaignName',
    label: '推广计划名称',
    placeholder: '请输入推广计划名称关键字，多个关键字以英文逗号隔开',
    type: 'Input',
  },
  wechatSpid: {
    value: 'wechatSpid',
    label: '微信服务商ID',
    placeholder: '请输入微信服务商ID，多个以英文逗号分隔',
    type: 'Input',
  },
  agencyId: {
    value: 'agencyId',
    label: '服务商ID',
    placeholder: '请输入服务商ID，多个以英文逗号分隔',
    type: 'Input',
  },
  area: {
    value: 'area',
    label: '所在地',
    placeholder: '请输入所在地，多个以英文逗号分隔',
    type: 'Input',
  },
  telLocation: {
    value: 'telLocation',
    label: '号码归属地',
    placeholder: '请输入号码归属地，多个以英文逗号分隔',
    type: 'Input',
  },
};

// 广告名称、推广计划名称、所在地、号码归属地 用到模糊匹配，其他都是精准匹配 by fighting
export const FuzzyMatchFieldNames = [
  'adName',
  'campaignName',
  'area',
  'telLocation'
];

export const getStandardFieldMap = ({ isShowXjLeadsSubSource = false, source = 0 }) => {
  const dynamicFiledMap = {
    ...standardFieldMap,
    ...(window.pageProps.xundaOuterCode !== 0 && {
      userGroupId: {
        value: 'userGroupId',
        label: '团队ID',
        placeholder: '请输入团队ID',
        type: 'Input',
      },
    }),
    // 房讯达才有楼盘名称项
    ...(isXunda() &&
    source !== 0 && {
      leadsPoolId: {
        value: 'leadsPoolId',
        label: `${getXundaPoolKeyName()  }名称`,
        placeholder: `请选择${getXundaPoolKeyName()}名称`,
        type: 'Select',
        data: [],
      },
    }),
    ...(isShowLeadsSubSource && {
      leadsSubSource: {
        value: 'leadsSubSource',
        label: '二级线索来源',
        placeholder: '请选择二级线索来源',
        type: 'Select',
        data: Object.keys(leadsSubSourceMap).map((key) => ({
          value: key,
          label: leadsSubSourceMap[key],
        })),
      },
    }),
    ...(isShowXjLeadsSubSource && {
      leadsSubSource: {
        value: 'leadsSubSource',
        label: '二级线索来源',
        placeholder: '请选择二级线索来源',
        type: 'Select',
        data: Object.keys(xuanjLeadsSubSourceMap).map((key) => ({
          value: key,
          label: xuanjLeadsSubSourceMap[key],
        })),
      },
    }),
    ...(window.pageProps.isInnerAccount && {
      sourceAccountId: {
        value: 'sourceSuperAccountId__sourceAccountId',
        label: '来源广告主账号',
        placeholder: '请输入来源广告主账号',
        type: 'Input',
      },
      lgMethod: {
        value: 'lgMethod',
        label: 'LG处理方式',
        placeholder: '请选择LG处理方式',
        type: 'Select',
        data: Object.keys(Tags.lgMethodTags).map((key) => ({
          value: key,
          label: Tags.lgMethodTags[key],
        })),
      },
    }),
  };
  return dynamicFiledMap;
};

export const RuleApplyRangeType = {
  ALL: '不限',
  CUSTOMIZE: '自定义',
};

export const LogicRelation = {
  AND: '与',
  OR: '或',
};

export const LogicNewRelation = {
  AND: '且',
  OR: '或',
};

export const MatchRelationType = {
  IN: '等于',
  NOT_IN: '不等于',
};

// add by fighting
export const ContainRelationType = {
  IN: '包含',
  NOT_IN: '不包含',
};
// 展示包含或者等于
export const RelationShipType = {
  FUZZY_MATCH: 'FUZZY_MATCH', // 显示查询谓词为包含/不包含
  EXACT_MATCH: 'EXACT_MATCH', // 显示查询谓词为等于/不等于
}

export const FieldScope = {
  STANDARD: '标准字段',
  BUNDLE: '表单字段',
};

export const renderRangeDetail = (applyRange) => {
  if (applyRange.applyRangeType === 'ALL') {
    return '不限';
  }
  if (!applyRange.applyRangeDetail || applyRange.applyRangeDetail.length === 0) {
    return '';
  }
  const firstCondition = applyRange.applyRangeDetail[0];
  let fieldName;
  let fieldValues;
  if (firstCondition.fieldScope === 'STANDARD') {
    const standardField = standardFieldMap[firstCondition.fieldName];
    if (!standardField || !standardField.label) {
      return '';
    }
    fieldName = standardField.label;
    if (standardField.type === 'Select') {
      fieldValues = [];
      standardField.data.forEach((item) => {
        if (firstCondition.fieldValues.includes(item.value)) {
          fieldValues.push(item.label);
        }
      });
    } else if (standardField.type === 'SelectTree') {
      fieldValues = [];
      standardField.data.forEach((item) => {
        if (firstCondition.fieldValues.includes(item.value)) {
          fieldValues.push(item.desc);
        } else if (item.options && item.options.length > 0) {
          item.options.forEach((option) => {
            if (firstCondition.fieldValues.includes(option.value)) {
              fieldValues.push(option.desc);
            }
          });
        }
      });
    } else {
      fieldValues = firstCondition.fieldValues;
    }
  } else {
    fieldName = firstCondition.fieldName;
    fieldValues = firstCondition.fieldValues;
  }

  return `${fieldName} ${MatchRelationType[applyRange.applyRangeDetail[0].matchRelation]} "${fieldValues.join(',')}"${
    applyRange.applyRangeDetail.length > 1 ? '...' : ''
  }`;
};
